/* unplugin-vue-components disabled */import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=c037d78c&lang=scss"

const __exports__ = script;

export default __exports__